import React from "react";

export default function ReviewStar() {
  return (
    <>
      <div className="lc-icon lc-icon-star-filled lc-icon-sm sm:tw-hidden" />
      <div className="lc-icon lc-icon-star-filled lc-icon-md tw-hidden sm:tw-block" />
    </>
  );
}
